import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/shared/utils.service';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { Promotion } from '../promotion.model';
import { Product } from 'src/app/shared/product.model';
import {DeletePromotionComponent} from "../promotions/delete-promotion/delete-promotion.component";
import {AddPromotionComponent} from "../promotions/add-promotion/add-promotion.component";
import { ExportService } from '../../shared/export.service';

@Component({
    selector: 'app-manufacturer',
    templateUrl: './manufacturer.component.html',
    styleUrls: ['./manufacturer.component.scss'],
    standalone: false
})
export class ManufacturerComponent implements OnInit {
  showSearchProduct: boolean;
  showSearchSponsor: boolean;
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  pageSize = 10;
  sponsorPageSize = 10;
  pageNumber = 1;
  sponsorPageNumber = 1;
  manufactourerName!: string;
  manufacturerId!: number;
  userID: any;
  promotionsList = new Array<Promotion>();
  productsList = new Array<Product>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    pageIndex: number;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    pageIndex: 0
  };

  productSearchValue = "";
  sponsorSearchValue  = "";
  sponsorsTotalSize = 0;
  totalSize = 0;
  selected = new FormControl(0);

  constructor(public dialog: MatDialog,
              private route: ActivatedRoute,
              public utils: UtilsService,
              public dataService: DataService,
              private authService: AuthService,
              private router: Router,
              private exportService: ExportService
              ) {
                this.showSearchProduct = false;
                this.showSearchSponsor = false;
                this.userID = this.authService.getUserData().id;
                this.route.params.subscribe((params: Params) => {
                  this.manufactourerName = params.name;
                  this.manufacturerId = params.id;
                });
                this.route.queryParams.subscribe((params: Params) => {
                  if (!this.isEmpty(params)) {
                    if (params.pageIndex === "1") {
                      this.selected.setValue(0);
                      this.pageNumber = params.pageNumber ? params.pageNumber : 1;
                      this.pageSize = params.pageSize ? params.pageSize : 10;
                      this.productSearchValue =  params.searchValue ? params.searchValue : "";
                      this.getProducts();
                    } else if (params.pageIndex === "2") {
                      this.selected.setValue(1);
                      this.sponsorPageNumber = params.pageNumber ? params.pageNumber : 1;
                      this.sponsorPageSize = params.pageSize ? params.pageSize : 10;
                      this.sponsorSearchValue =  params.searchValue ? params.searchValue : "";
                      this.getPromotions();
                    }else {
                      this.getProducts();
                    }
                  } else {
                    this.getProducts();
                  }
                });
              }


  ngOnInit(): void {
    this.utils.setTitle('Manufacturers');
    this.utils.screenTitle.emit({firstTitle: 'Manufacturers', firstRoute: '/manufacturers',
      secondTitle: this.manufactourerName, secondRoute: '/manufacturers/manufacturer/'  + this.manufacturerId + '/' + this.manufactourerName,
    });
    this.searchForm = new FormGroup({
      productSearch: new FormControl(this.productSearchValue),
      sponsorSearch: new FormControl(this.sponsorSearchValue),
    });

    if (this.productSearchValue) {  
      this.showSearchProduct = true;
    }
    if (this.sponsorSearchValue) {
      this.showSearchSponsor = true;
    }
    
    this.searchForm.get('productSearch')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.productSearchValue !== '') {
        setTimeout(() => this.clearProductSearch(), 0);
      }
    });
    this.searchForm.get('sponsorSearch')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.sponsorSearchValue !== '') {
        setTimeout(() => this.clearSponsorSearch(), 0);
      }
    });
  }
  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  requestAccess(id: any) {
    const payloadd = {
      ProductsIds: [id],
      ManufacturerId: parseInt(this.manufacturerId.toString(), 10),
      IsNewProduct: false
    };

  this.dataService.post('ProductAccessRequest/ApplyForManufacturerSupport', payloadd).then((data: any) => {
    if (data.statusCode === 200) {
      this.getProducts();
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Request sent successfully',
          type: 'Success',
          message: 'Your request has been sent successfully, thank you!',
          buttonText: 'Ok'
        }
      });
    } else if (data.statusCode === 623) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'Request already sent!',
          buttonText: 'Ok',
          closeDialogRef: true
        }
      });
    }  else {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Error',
          type: 'Error',
          message: 'Something went wrong, Please try again!',
          buttonText: 'Ok'
        }
      });
    }
  });
  }

  onTabChange(event: any){
    this.selected.setValue(event);
    this.pageNumber = 1;
    this.sponsorPageNumber = 1;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.productSearchValue, pageIndex: event + 1};
    this.router.navigate(['/manufacturers/manufacturer/' + this.manufacturerId + '/' + this.manufactourerName], { queryParams: this.queryParams });
  }

  handleProductPage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.productSearchValue, pageIndex: 1};
    this.router.navigate(['/manufacturers/manufacturer/' + this.manufacturerId + '/' + this.manufactourerName], { queryParams: this.queryParams });
  }
  handleSponsorsPage(e: any) {
    this.sponsorPageNumber = e.pageIndex + 1;
    this.sponsorPageSize = e.pageSize;
    this.queryParams = {pageNumber: this.sponsorPageNumber,
      pageSize: this.sponsorPageSize, searchValue: this.sponsorSearchValue, pageIndex: 2};
    this.router.navigate(['/manufacturers/manufacturer/' + this.manufacturerId + '/' + this.manufactourerName], { queryParams: this.queryParams });
  }

  handleProductSearchClick() {
    if (this.showSearchProduct && this.productsList.length > 0) {
      this.doProductSearch();
    } else {
      this.showSearchProduct = true;
    }
  }
  handleSponsorSearchClick() {
    if (this.showSearchSponsor && this.promotionsList.length > 0) {
      this.doSponsorSearch();
    } else {
      this.showSearchSponsor = true;
    }
  }
  doProductSearch() {
    let searchInput = this.searchForm.get('productSearch')?.value || '';
    this.productSearchValue = searchInput.trim();
    this.searchForm.get('productSearch')?.setValue(this.productSearchValue, { emitEvent: false });

    if (this.productSearchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.productSearchValue, pageIndex: 1};
      this.router.navigate(['/manufacturers/manufacturer/' + this.manufacturerId + '/' + this.manufactourerName], { queryParams: this.queryParams });
    }
  }
  doSponsorSearch() {
    let searchInput = this.searchForm.get('sponsorSearch')?.value || '';
    this.sponsorSearchValue = searchInput.trim();
    this.searchForm.get('sponsorSearch')?.setValue(this.sponsorSearchValue, { emitEvent: false });
    
    if (this.sponsorSearchValue) {
      this.sponsorPageNumber = 1;
      this.queryParams = {pageNumber: this.sponsorPageNumber,
        pageSize: this.sponsorPageSize, searchValue: this.sponsorSearchValue, pageIndex: 2};
      this.router.navigate(['/manufacturers/manufacturer/' + this.manufacturerId + '/' + this.manufactourerName], { queryParams: this.queryParams });
    }
  }

  clearProductSearch() {
    this.showSearchProduct = !this.showSearchProduct;
    this.searchForm.get('productSearch')?.setValue('');
    this.productSearchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.productSearchValue,
      pageIndex: 1
    };
    this.router.navigate(['/manufacturers/manufacturer/' + this.manufacturerId + '/' + this.manufactourerName], { queryParams: this.queryParams });
  }

  clearSponsorSearch() {
    this.showSearchSponsor = !this.showSearchSponsor;
    this.searchForm.get('sponsorSearch')?.setValue('');
    this.sponsorSearchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.sponsorSearchValue,
      pageIndex: 2
    };
    this.router.navigate(['/manufacturers/manufacturer/' + this.manufacturerId + '/' + this.manufactourerName], { queryParams: this.queryParams });
  }

  notAllowedMessage(id: any, name: any) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: name,
        type: 'Warn',
        header: 'Access Request',
        message: 'You need permission to access product details.',
        buttonText: 'cancel',
        numberOfButtons: 2,
        seconButtonText: 'Send request'
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status === 'Send request') {
        this.requestAccess(id);
      }
    });
  }

  openProduct(allowed: boolean, id: any, name: any) {
    if (!allowed) {
      this.notAllowedMessage(id, name);
    } else {
      this.router.navigate(['/products/product/' + id + '/' + name]);
    }
  }

  onImgError(event: any) {
    this.utils.theme$.subscribe((isDark: any) => {
      event.target.src  = isDark
        ? '../../../assets/images/products-dark.png'
        : '../../../assets/images/products-light.png';
    });
  }

  truncateDescription(desc: string) {
    if (desc.length  > 140) {
      desc = desc.slice(0, 140) + '...';
    }
    return desc;
  }

  getPromotions() {
      this.dataService.get('promotionCode/RetrievePromotionCodeByUserId/' +
      parseInt(this.manufacturerId.toString(), 10) + '?pageNumber=' + this.sponsorPageNumber +
      '&pageSize=' + this.sponsorPageSize +
      '&searchKeyword=' + this.sponsorSearchValue).then((data: any) => {
        if (data.statusCode === 200) {
          this.promotionsList = [];
          const promotionsData = data.data.records;
          this.sponsorsTotalSize = data.data.count;
          promotionsData.forEach((promotionData: any) => {
            const promotionInstance = new Promotion(promotionData);
            this.promotionsList.push(promotionInstance);
          });
          if (promotionsData.length === 0 && this.sponsorsTotalSize > 0) {
            this.sponsorPageNumber = 1;
            this.queryParams = {pageNumber: this.sponsorPageNumber,
              pageSize: this.sponsorPageSize, searchValue: this.sponsorSearchValue, pageIndex: 2};
            this.router.navigate(['/manufacturers/manufacturer/' + this.manufacturerId + '/' + this.manufactourerName],
            { queryParams: this.queryParams });
          }
        }
      });
    }
    getProducts() {
      this.dataService.get('product/RetrieveallProducts/' +
      parseInt(this.manufacturerId.toString(), 10) + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.productSearchValue).then((data: any) => {
        if (data.statusCode === 200) {
          this.productsList = [];
          const productsData = data.data.records;
          this.totalSize = data.data.count;
          productsData.forEach((productData: any) => {
            const productInstance = new Product(productData);
            this.productsList.push(productInstance);
          });
          if (productsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber,
              pageSize: this.pageSize, searchValue: this.productSearchValue, pageIndex: 1};
            this.router.navigate(['/manufacturers/manufacturer/' + this.manufacturerId + '/' + this.manufactourerName],
            { queryParams: this.queryParams });
          }
        }
      });
    }

  openAddPromotion() {
    const dialogRef = this.dialog.open(AddPromotionComponent, {disableClose: true, width: '400px',
    data:{userID:this.manufacturerId}
    });
    dialogRef.afterClosed().subscribe((newPromotions) => {
      if (newPromotions.length > 0) {
        this.getPromotions();
      }
    });
  }

  deletePromotion(id: any, code: any) {
    const dialogRef = this.dialog.open(DeletePromotionComponent, {
      disableClose: true,
      width: '400px',
      data: {
        id,
        code
      }});
    dialogRef.afterClosed().subscribe((status) => {
      if (status === 'delete') {
        this.promotionsList.forEach( (promotion, index) => {
          if (promotion.id === id) {
            this.promotionsList.splice(index, 1);
            if (this.promotionsList.length === 0 && this.pageNumber > 1){
              this.queryParams = {pageNumber: this.sponsorPageNumber,
                pageSize: this.sponsorPageSize, searchValue: this.sponsorSearchValue, pageIndex: 2};
              this.router.navigate(['/manufacturers/manufacturer/' + this.manufacturerId + '/' + this.manufactourerName],
                { queryParams: this.queryParams });
            } else {
              this.getPromotions();
            }
          }
        });
      }
    });
  }

  exportManufacturerProducts(fileTypeId: number) {
    this.exportService.exportFile(`product/ExportAllProducts/${this.manufacturerId}`, fileTypeId, this.productSearchValue, 'manufaturerProducts');
  }

  exportManufacturerSponsoring(fileTypeId: number) {
    this.exportService.exportFile(`promotionCode/export/PromotionCodeByUserId/${this.manufacturerId}`, fileTypeId, this.sponsorSearchValue, 'manufacturerSponsoring');
  }
}
